import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { configureAppStore } from "./store";
import addAuthTokenInterceptor from "./api/addAuthTokenInterceptor";
import { Provider as StoreProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
const configureStore = configureAppStore();

addAuthTokenInterceptor(configureStore.store);
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Suspense fallback="loading">
      <StoreProvider store={configureStore.store}>
        <PersistGate loading={<></>} persistor={configureStore.persistor}>
          <App />
        </PersistGate>
      </StoreProvider>
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (import.meta.env.PROD) {
  console.log = () => {};    // Disable console.log in production
  console.warn = () => {};   // Optional: Disable console.warn
  console.error = () => {};  // Optional: Disable console.error
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js').then((registration) => {
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New content is available, reload the page
          console.log('New version available. Reloading...');
          // window.location.reload();
        }
      });
    });
  });

  // Remove old service workers if necessary
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      if (!registration.active) {
        registration.unregister();
      }
    });
  });
}
